export enum WalletType {
  EVM = 'EVM',
  Substrate = 'Substrate',
}
